<div class="container">
    <h5 class="mb-3 rps-heading-five">Product summary</h5>
    <div  *ngIf="overviewModel?.isInternalFund" class="col-md-12 summary rps-paragraph-one">
        <div *ngIf="overviewModel?.productSummary; else mdash" [innerHtml]="overviewModel.productSummary" data-rpa-tag-id="productSummary"></div>
        <ng-template #mdash>
            <h4 class="rps-heading-four" data-rpa-tag-id="productSummary">&mdash;</h4>
        </ng-template>
    </div>

    <div  *ngIf="overviewModel?.isExternalFund" class="col-md-12 summary rps-paragraph-one">
        <div *ngIf="overviewModel?.overview; else mdash" [innerHtml]="overviewModel.overview"></div>
        <ng-template #mdash>
            <h4 class="rps-heading-four">&mdash;</h4>
        </ng-template>
    </div>
</div>